import React, { type ReactElement } from 'react';
import { type MapStateToProps, connect } from 'react-redux';

import styles from '../../../sass/definitions/_media-queries.scss';
import * as D from '../deps';
import { isBackstageRightRailActive } from '../utils';

import BackstageRowGrid from './BackstageRowGrid';
import BackstageSortDropdown from './BackstageSortDropdown';

const BREAK_WIDTH_RIGHT_RAIL = 1440;

export interface IBackstagePlayableRowGridStateProps {
  isMobileDevice: ReturnType<typeof D.isMobileWeb>;
  isBreakWidth: boolean;
}

export interface IBackstagePlayableRowGridOwnProps {
  contentSection?: string;
  title?: string | $TSFixMe;
  onSeeAllClick?: $TSFixMeFunction;
  moreUrl?: string | null;
  moreText?: string | $TSFixMe;
  secondMoreText?: string | $TSFixMe;
  isCuratorStations?: boolean;
  isWidthHalf?: boolean;
  isFirstSection?: boolean;
  children: ReactElement[];
  sortTypes?: $TSFixMe[];
  onSortChange?: $TSFixMeFunction;
}

export type IBackstagePlayableRowGridProps = IBackstagePlayableRowGridStateProps &
  IBackstagePlayableRowGridOwnProps;

const BackstagePlayableRowGrid: React.FC<IBackstagePlayableRowGridProps> = props => {
  const {
    contentSection,
    title,
    onSeeAllClick,
    moreUrl,
    moreText,
    secondMoreText,
    isMobileDevice,
    isWidthHalf = true,
    isBreakWidth,
    sortTypes,
    onSortChange,
    isFirstSection,
    children,
  } = props;

  const integrationData = { contentSection };

  const hasSingleChild = React.Children.toArray(children).length === 1;

  return (
    <D.AppContextIntegrationData data={integrationData}>
      <D.ContentSection
        isPlayableRowGrid={true}
        // @ts-expect-error TS(2322) FIXME: Type '{ children: Element; isPlayableRowGrid: true... Remove this comment to see the full error message
        isCuratorStations={props.isCuratorStations}
        title={title}
        moreText={moreText}
        secondMoreText={secondMoreText}
        moreTextOnclick={onSeeAllClick}
        moreUrl={moreUrl}
        disableHover={isMobileDevice}
        sortDropdownMenu={
          sortTypes &&
          onSortChange && (
            <BackstageSortDropdown sortTypes={sortTypes} onSortChange={onSortChange} />
          )
        }
        isFirstSection={isFirstSection}
      >
        <div className='PlayableRowGrid' data-qa={D.Constants.QATags.BPRG}>
          <BackstageRowGrid>
            {React.Children.map(children, child =>
              React.cloneElement(child, {
                isWidthHalf: !hasSingleChild && isWidthHalf && !isBreakWidth,
              }),
            )}
          </BackstageRowGrid>
        </div>
      </D.ContentSection>
    </D.AppContextIntegrationData>
  );
};

export const mapStateToProps: MapStateToProps<
  IBackstagePlayableRowGridStateProps,
  IBackstagePlayableRowGridOwnProps,
  $TSFixMe
> = state => {
  const { width } = D.getViewportDimensions();
  const isRightRailActive = isBackstageRightRailActive(state);
  const breakWidth = isRightRailActive
    ? BREAK_WIDTH_RIGHT_RAIL
    : parseInt(styles.BREAK_WIDTH_S, 10);

  return {
    isMobileDevice: D.isMobileWeb(state),
    isBreakWidth: width < breakWidth,
  };
};

export default connect(mapStateToProps)(BackstagePlayableRowGrid);
